import BlueTreeCute from '../src/assets/bag/BlueTreeCute.jpg';
import BlueTreeCute1 from '../src/assets/bag/BlueTreeCute1.jpg';
import BlueTreeCutebatman from '../src/assets/bag/BlueTreeCutebatman.jpg';
import BlueTreeCutebatman1 from '../src/assets/bag/BlueTreeCutebatman1.jpg';
import Dejan from '../src/assets/bag/Dejan.jpg';
import Dejan1 from '../src/assets/bag/Dejan1.jpg';
import DisneyBelle from '../src/assets/bag/DisneyBelle.jpg';
import DisneyBelle1 from '../src/assets/bag/DisneyBelle1.jpg';
import DisneyMarvelAvengers from '../src/assets/bag/DisneyMarvelAvengers.jpg';
import DisneyMarvelAvengers1 from '../src/assets/bag/DisneyMarvelAvengers1.jpg';
import DisneyMarvelSpiderman from '../src/assets/bag/DisneyMarvelSpiderman.jpg';
import DisneyMarvelSpiderman1 from '../src/assets/bag/DisneyMarvelSpiderman1.jpg';
import DisneyMickeyMouse from '../src/assets/bag/DisneyMickeyMouse.jpg';
import DisneyMickeyMouse1 from '../src/assets/bag/DisneyMickeyMouse1.jpg';
import DisneyPrincessBelle from '../src/assets/bag/DisneyPrincessBelle.jpg';
import DisneyPrincessBelle1 from '../src/assets/bag/DisneyPrincessBelle1.jpg';
import DisneySnowWhite from '../src/assets/bag/DisneySnowWhite.jpg';
import DisneySnowWhite1 from '../src/assets/bag/DisneySnowWhite1.jpg';
import FranticVelvet from '../src/assets/bag/FranticVelvet.jpg';
import FranticVelvet1 from '../src/assets/bag/FranticVelvet1.jpg';
import FurJadenHikingCamping from '../src/assets/bag/FurJadenHikingCamping.jpg';
import FurJadenHikingCamping1 from '../src/assets/bag/FurJadenHikingCamping1.jpg';
import GenieCamellia from '../src/assets/bag/GenieCamellia.jpg';
import GenieCamellia1 from '../src/assets/bag/GenieCamellia1.jpg';
import Happile from '../src/assets/bag/Happile.jpg';
import Happile1 from '../src/assets/bag/Happile1.jpg';
import LavieSport from '../src/assets/bag/LavieSport.jpg';
import LavieSport1 from '../src/assets/bag/LavieSport1.jpg';
import motupatlo from '../src/assets/bag/motupatlo.jpg';
import motupatlo1 from '../src/assets/bag/motupatlo1.jpg';

const Kdata = [
    {
        img1: BlueTreeCute,
        img2: BlueTreeCute1,
        title: "Blue Tree Cute",
        price: "299"
    },
    {
        img1: DisneyBelle,
        img2: DisneyBelle1,
        title: "Disney Belle",
        price: "199"
    },
    {
        img1: DisneyMarvelAvengers,
        img2: DisneyMarvelAvengers1,
        title: "Marvel Avengers",
        price: "399"
    },
    {
        img1: DisneyMarvelSpiderman,
        img2: DisneyMarvelSpiderman1,
        title: "Marvel Spiderman",
        price: "299"
    },
    {
        img1: DisneyMickeyMouse,
        img2: DisneyMickeyMouse1,
        title: "Disney Mickey Mouse",
        price: "299"
    },
    {
        img1: DisneyPrincessBelle,
        img2: DisneyPrincessBelle1,
        title: "Disney Princess Belle",
        price: "399"
    },
    {
        img1: DisneySnowWhite,
        img2: DisneySnowWhite1,
        title: "DisneySnowWhite",
        price: "299"
    },
    {
        img1: FranticVelvet,
        img2: FranticVelvet1,
        title: "Frantic Velvet",
        price: "199"
    },
    {
        img1: FurJadenHikingCamping,
        img2: FurJadenHikingCamping1,
        title: "Hiking Camping",
        price: "159"
    },
    {
        img1: GenieCamellia,
        img2: GenieCamellia1,
        title: "Genie Camellia",
        price: "299"
    },
    {
        img1: Happile,
        img2: Happile1,
        title: "Happile",
        price: "199"
    },
    {
        img1: LavieSport,
        img2: LavieSport1,
        title: "Lavie Sport",
        price: "399"
    },
    {
        img1: motupatlo,
        img2: motupatlo1,
        title: "motu Patlo",
        price: "199"
    },
    {
        img1: Dejan,
        img2: Dejan1,
        title: "Dejan ",
        price: "399"
    },
    {
        img1: BlueTreeCutebatman,
        img2: BlueTreeCutebatman1,
        title: "Blue Tree Cute batman",
        price: "399"
    },
]
export default Kdata;